// Who sees Delete enabled on Customer Projects and Employees, and which
// endpoint a row goes to.
//
// canDeleteUser mirrors the role part of the admin's
// AccessPolicy.may_delete_user: an Organization Admin deletes Customers,
// Employees and Branch Admins; a Branch Admin deletes Customers and Employees;
// nobody else deletes, and nobody deletes their own row. The admin stays the
// gate: its branch rule can't be known here, so a Delete it refuses comes
// back 403 and the page shows that. An unknown caller or row role is
// disabled (fails closed).
//
// Pure: no React, fetch or toast.

const DELETABLE_ROLES = Object.freeze({
  "Organization Admin": Object.freeze(["customer", "employee", "branch_admin"]),
  "Branch Admin": Object.freeze(["customer", "employee"]),
});

// "customer" for a Customer row (the Employees page's All tab marks them
// type "customer"), else "employee". A Customer goes through
// customers/delete; the staff route refuses a Customer target.
export function deleteKindFor(row) {
  return row?.type === "customer" || row?.role === "customer" ? "customer" : "employee";
}

// { callerJobTitle, targetRole, isCurrentUser } -> whether Delete is enabled.
// targetRole is the row's role: "customer", "employee", "branch_admin" or
// "org_admin".
export function canDeleteUser({ callerJobTitle, targetRole, isCurrentUser = false } = {}) {
  if (isCurrentUser) return false;
  if (!Object.prototype.hasOwnProperty.call(DELETABLE_ROLES, callerJobTitle)) return false;
  return DELETABLE_ROLES[callerJobTitle].includes(targetRole);
}
